module.exports = __webpack_public_path__ + "img/ic-package-slip-white.a86d37ab.svg";